import axios, { AxiosInstance } from 'axios'
import { buildRequestTracingHeaders } from 'tracing/httpTracing'
import { getToken } from 'utils/localStorageUtils'
import browserHistory from '../browserHistory'
import {
  PATH_CROSSDOCK_INBOUND_PALLETS,
  PATH_CROSSDOCK_ORDER,
  PATH_CUSTOMERS,
  PATH_PRODUCTION_ORDER,
  PATH_QUALITY_ORDERS,
  PATH_RECODED_ORDER,
  PATH_REPACKAGED_ORDER,
  PATH_STATIONS,
} from './pathConstants'

export const httpClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 50000,
})

let centerId: string | number | null = null

export const setCenterId = (id: string | number) => {
  centerId = id
}

const PATHS_WITH_CENTER_ID_HEADER = [
  PATH_PRODUCTION_ORDER,
  PATH_QUALITY_ORDERS,
  PATH_CROSSDOCK_ORDER,
  PATH_REPACKAGED_ORDER,
  PATH_RECODED_ORDER,
  PATH_STATIONS,
  PATH_CUSTOMERS,
  PATH_CROSSDOCK_INBOUND_PALLETS,
]

httpClient.interceptors.request.use(
  async (requestConfig) => {
    requestConfig.headers = requestConfig.headers || {}

    if (getToken()) {
      requestConfig.headers.Authorization = `Bearer ${getToken()}`
    }

    Object.assign(requestConfig.headers, await buildRequestTracingHeaders())

    if (centerId) {
      const currentPath = requestConfig.url?.split('?')[0]
      if (currentPath && PATHS_WITH_CENTER_ID_HEADER.includes(currentPath)) {
        requestConfig.headers['center-id'] = String(centerId)
      }
    }

    return requestConfig
  },
  (error) => Promise.reject(error),
)

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (browserHistory.location.pathname !== '/login') {
        browserHistory.push('/logout')
      }
    }

    return Promise.reject(error)
  },
)
